import CreativePreview from '~/components/creative-preview/CreativePreview.vue';

export default {
  props: {
    creative: Object,
    facebookPage: Object,
    landingPage: Object,
    disabledButtons: {
      type: Boolean,
      default: true,
    },
    isTimeline: {
      type: Boolean,
      default: false,
    },
    mobilePreview: {
      type: Boolean,
      default: false,
    },
    enableFormPreview: {
      type: Boolean,
      default: false,
    },
    showCreativeIdBottom: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    'creative-preview': CreativePreview,
  },
  methods: {
    scale() {
      if (!this.$el) {
        return;
      }
      const preview = this.$el.querySelector('.creative-scale-preview');
      const spaceHolder = this.$el.querySelector('.creative-scale-place-holder');
      const switcher = this.$el.querySelector('.switcher');
      const card = preview.querySelector('.card');
      const leadModalButton = preview.querySelector('.lead-modal-button');
      if (card) {
        const height = card.getBoundingClientRect().height +
            (leadModalButton ? leadModalButton.getBoundingClientRect().height : 0) +
            (switcher ? switcher.getBoundingClientRect().height : 0);
        spaceHolder.style.height = `${height}px`;
        const creativeInfoBox = this.$el.querySelector('.form-creative-id');
        if (creativeInfoBox) {
          creativeInfoBox.style.width = `${card.getBoundingClientRect().width}px`;
          creativeInfoBox.style.marginLeft = `-${card.getBoundingClientRect().width / 2}px`;
        }
      }
    },
  },
  mounted() {
    this.scale();
    window.addEventListener('resize', this.scale);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.scale);
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/creative-preview-scaled/CreativePreviewScaled.js